<template v-cloak>
  <div class="animated fadeIn">
    <b-row style="width: 100%;" v-if="show">
      <component v-for="(item, index) in widgets"
        :key="`dashboard-widget-${index}`"
        :is="item">
      </component>
    </b-row>
  </div>
</template>

<script>
import Widgets from '@/components/widgets'
import { mapGetters } from 'vuex'
import { isEmpty } from 'lodash'

export default {
  data () {
    return {
      widgets: [
        Widgets.General.Contacts,
        Widgets.General.Budgets
      ]
    }
  },

  computed: {
    ...mapGetters({
      loggedUser: 'auth/user'
    }),

    show () {
      const self = this
      if (!isEmpty(self.loggedUser)) {
        const role = self.loggedUser.main_role.slug

        if (role === 'admin' || role === 'marketing') {
          return true
        }

        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Dashboard.vue